import * as core from '../../../../../../../core'

import { query } from './delete-subrecipient.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.actions.delete-subrecipient',
    description: 'Delete Subrecipient',
    name: 'Delete Subrecipient',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
